<template>
  <div class="menu-card-view">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1>Gestiu00f3n de Menu00fas - Estilo 2</h1>
      <div class="d-flex gap-2">
        <button @click="exportToExcel" class="btn btn-success">
          <i class="bi bi-file-earmark-excel me-1"></i> Exportar a Excel
        </button>
        <button @click="addMenu" class="btn btn-primary">
          <i class="bi bi-plus-circle me-1"></i> Nuevo Menu00fa
        </button>
      </div>
    </div>
    
    <!-- Filtros -->
    <div class="card mb-4 bg-light">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterTitulo">Tu00edtulo</label>
              <input 
                type="text" 
                id="filterTitulo" 
                class="form-control" 
                placeholder="Buscar por tu00edtulo"
                :value="controller.filters.titulo"
                @input="updateFilter('titulo', $event.target.value)"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterEnlace">Enlace</label>
              <input 
                type="text" 
                id="filterEnlace" 
                class="form-control" 
                placeholder="Buscar por enlace"
                :value="controller.filters.enlace"
                @input="updateFilter('enlace', $event.target.value)"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterEstado">Estado</label>
              <select 
                id="filterEstado" 
                class="form-select"
                :value="controller.filters.estado"
                @change="updateFilter('estado', $event.target.value)"
              >
                <option value="">Todos</option>
                <option value="true">Activos</option>
                <option value="false">Inactivos</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Alertas -->
    <div class="alert alert-info" v-if="loading">Cargando menu00fas...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <!-- Vista de tarjetas -->
    <div v-if="!loading && !error">
      <div v-if="filteredMenus.length === 0" class="alert alert-warning">
        No se encontraron menu00fas con los filtros aplicados
      </div>
      
      <div class="row">
        <div v-for="menu in filteredMenus" :key="menu.Menu_id" class="col-md-4 mb-4">
          <div class="card h-100 menu-card" :class="{'border-success': menu.Es_activo, 'border-danger': !menu.Es_activo}">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0 text-truncate" :title="menu.Titulo">
                {{ menu.Titulo }}
              </h5>
              <span :class="menu.Es_activo ? 'badge bg-success' : 'badge bg-danger'">
                {{ menu.Es_activo ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
            <div class="card-body">
              <p class="card-text description" :title="menu.Descripcion">{{ menu.Descripcion || 'Sin descripciu00f3n' }}</p>
              
              <div class="menu-details">
                <div class="menu-detail-item">
                  <span class="detail-label"><i class="bi bi-link"></i> Enlace:</span>
                  <span class="detail-value text-truncate" :title="menu.Enlace">{{ menu.Enlace || 'No definido' }}</span>
                </div>
                
                <div class="menu-detail-item">
                  <span class="detail-label"><i class="bi bi-diagram-3"></i> Menu00fa Padre:</span>
                  <span class="detail-value">{{ menu.Menu_id_padre || 'Ninguno' }}</span>
                </div>
                
                <div class="menu-detail-item">
                  <span class="detail-label"><i class="bi bi-sort-numeric-down"></i> Orden:</span>
                  <span class="detail-value">{{ menu.Orden }}</span>
                </div>
                
                <div class="menu-detail-item">
                  <span class="detail-label"><i class="bi bi-arrow-up-square"></i> Es Top:</span>
                  <span class="detail-value">
                    <i :class="menu.Es_top ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle-fill text-danger'"></i>
                    {{ menu.Es_top ? 'Su00ed' : 'No' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="card-footer bg-transparent d-flex justify-content-end">
              <button @click="editMenu(menu)" class="btn btn-sm btn-warning me-2">
                <i class="bi bi-pencil"></i> Editar
              </button>
              <button @click="confirmDelete(menu)" class="btn btn-sm btn-danger">
                <i class="bi bi-trash"></i> Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal de confirmaciu00f3n -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar eliminaciu00f3n</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-if="menuToDelete">
            u00bfEstu00e1 seguro que desea eliminar el menu00fa "{{ menuToDelete.Titulo }}"?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger" @click="deleteMenu">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import MenuTableView1Controller from '../controllers/MenuTableView1Ctrl.js';

export default {
  name: 'MenuTableView2',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new MenuTableView1Controller()
    };
  },
  computed: {
    filteredMenus() {
      return this.controller.filteredMenus;
    },
    loading() {
      return this.controller.isLoading;
    },
    error() {
      return this.controller.currentError;
    },
    menus() {
      return this.controller.menusList;
    },
    menuToDelete() {
      return this.controller.selectedMenuToDelete;
    }
  },
  async created() {
    await this.controller.initialize();
  },
  methods: {
    async fetchMenus() {
      await this.controller.loadMenus();
    },
    
    addMenu() {
      this.$router.push('/menus/add');
    },
    
    editMenu(menu) {
      this.$router.push(`/menus/edit/${menu.Menu_id}`);
    },
    
    confirmDelete(menu) {
      this.controller.setMenuToDelete(menu);
      // Mostrar modal de confirmación usando DOM nativo
      const modalEl = document.getElementById('deleteModal');
      if (modalEl) {
        modalEl.classList.add('show');
        modalEl.style.display = 'block';
        document.body.classList.add('modal-open');
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
      }
    },
    
    async deleteMenu() {
      try {
        await this.controller.deleteMenu();
        
        // Ocultar modal usando DOM nativo
        const modalEl = document.getElementById('deleteModal');
        if (modalEl) {
          modalEl.classList.remove('show');
          modalEl.style.display = 'none';
          document.body.classList.remove('modal-open');
          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) {
            document.body.removeChild(backdrop);
          }
        }
        
        this.$mgkAlert.success('Menú eliminado correctamente.');
      } catch (error) {
        this.$mgkAlert.error('No se pudo eliminar el menú. Por favor, intente nuevamente.');
      }
    },
    
    exportToExcel() {
      try {
        this.controller.exportToCSV();
        this.$mgkAlert.success('Datos exportados correctamente.');
      } catch (error) {
        this.$mgkAlert.error('Error al exportar los datos.');
      }
    },
    
    updateFilter(field, value) {
      this.controller.updateFilter(field, value);
    }
  }
};
</script>

<style scoped>
.menu-card-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.menu-card {
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-width: 2px;
}

.menu-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.75rem 1.25rem;
}

.card-title {
  max-width: 80%;
}

.description {
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.menu-details {
  margin-top: 1rem;
}

.menu-detail-item {
  display: flex;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.detail-label {
  font-weight: 600;
  width: 110px;
  color: #6c757d;
}

.detail-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
